export enum EnumStepFunctions {
  StepReadCrm = 'resultCRM',
  StepCreateCdt = 'resultCPP',
  StepAccountsCustomer = 'resultCA',
  StepSaveSummaryCdt = 'resultSST',
  resultES = 'resultES',
  resultCPP2 = 'resultCPP2',
  resultRSPI = 'resultRSPI',
  resultNAC = 'resultNAC',
  resultCI = 'resultCI',
  StepTransactionStatus = 'resultTS',
  StepReadSummaryTransaction = 'resultRST',
  StepFinishTransaction = 'resultFT',
  StepEndProcess = 'endProcessOK'
}
